"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInviteTime = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var UpdateInviteTime = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UpdateInviteTime, _super);
    function UpdateInviteTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '更新邀请时间接口';
        _this.code = '101037';
        _this.desc = '更新邀请时间接口';
        _this.requestParams = new point_1.UpdateInviteTimeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return UpdateInviteTime;
}(service_1.BaseService));
exports.UpdateInviteTime = UpdateInviteTime;
//# sourceMappingURL=updateInviteTime.js.map